import SearchBarV2 from "./SearchBarV2";

export default SearchBarV2;
